import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import {
  FETCH_USERS,
  SET_USERS,
  FETCH_CONTROLLERS,
  SET_CONTROLLERS,
  FETCH_USER_CONTROLLERS,
  SET_USER_CONTROLLERS,
  SET_OTA,
  SET_NEW_CONTROLLER,
  SET_UPDATE_CONTROLLER,
  FETCH_INVOICE,
  SET_INVOICE,
} from "./types";

const INITIAL_STATE = Immutable({
  users: {
    loading: false,
    data: [],
  },
  controller: {
    loading: {},
    data: [],
  },
  ota: {
    loading: false,
    data: [],
    currentVersion: "",
  },
  invoice: {
    loading: false,
    data: [],
  },
});

const fetchUser = (state) =>
  state.merge({
    ...state,
    users: {
      loading: true,
      data: [],
    },
  });

const setUser = (state, { payload }) =>
  state.merge({
    ...state,
    users: {
      loading: false,
      data: payload.map((item) => {
        return {
          ...item,
          key: item._id,
        };
      }),
    },
  });

const fetchController = (state) =>
  state.merge({
    ...state,
    controller: {
      loading: true,
      data: [],
    },
  });

const setController = (state, { payload }) =>
  state.merge({
    ...state,
    controller: {
      loading: false,
      data: payload.map((item) => {
        return {
          ...item,
          key: item._id,
        };
      }),
    },
  });

const setNewController = (state, { payload }) =>
  state.merge({
    ...state,
    controller: {
      loading: false,
      data: [payload, ...state.controller.data],
    },
  });

const updateController = (state, { payload }) =>
  state.merge({
    ...state,
    controller: {
      loading: false,
      data: state.controller.data.map((item) => {
        if (item._id === payload._id) {
          return payload;
        } else {
          return item;
        }
      }),
    },
  });

const fetchUserController = (state) =>
  state.merge({
    ...state,
    ota: {
      loading: true,
      data: [],
      currentVersion: "",
    },
  });

const setUserController = (state, { payload }) =>
  state.merge({
    ...state,
    ota: {
      loading: false,
      data: payload.controllers,
      currentVersion: payload.currentVersion,
    },
  });

const updateOta = (state, { payload }) =>
  state.merge({
    ...state,
    ota: {
      ...state.ota,
      data: state.ota.data.map((item) => {
        if (item._id === payload._id) {
          return {
            ...item,
            availableFirmwareUpdateVersion:
              payload.availableFirmwareUpdateVersion,
          };
        } else {
          return item;
        }
      }),
    },
  });

const fetchInvoice = (state) =>
  state.merge({
    ...state,
    invoice: {
      loading: true,
      data: [],
    },
  });

const setInvoice = (state, { payload }) =>
  state.merge({
    ...state,
    invoice: {
      loading: false,
      data: payload,
    },
  });

const reducers = createReducer(INITIAL_STATE, {
  [FETCH_USERS]: fetchUser,
  [SET_USERS]: setUser,
  [FETCH_CONTROLLERS]: fetchController,
  [SET_CONTROLLERS]: setController,
  [FETCH_USER_CONTROLLERS]: fetchUserController,
  [SET_USER_CONTROLLERS]: setUserController,
  [SET_OTA]: updateOta,
  [SET_NEW_CONTROLLER]: setNewController,
  [SET_UPDATE_CONTROLLER]: updateController,
  [FETCH_INVOICE]: fetchInvoice,
  [SET_INVOICE]: setInvoice,
});

export default reducers;
